import Swiper from 'swiper/core';

export default class Reviews {
  constructor(swiper) {
    this.dom = {
      swiper,
    };

    this.data = {
      swiperOptions: {
        spaceBetween: 30,
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination.dots',
          clickable: true,
        },
      },
    };

    this.components = {
      swiper: null,
    };

    this.mount();
  }

  mount() {
    this.initSwiper();
  }

  initSwiper() {
    this.components.swiper = new Swiper(
      this.dom.swiper,
      this.data.swiperOptions,
    );
  }
}
